import { ProjectModel } from '../../../../../gamma-api';

export const MAIN_CLASS_NAME = 'project-modal';
export const FORM_ITEM_CLASS_NAME = `${MAIN_CLASS_NAME}__form-item`;

export const EMPTY_PROJECT: ProjectModel = {
  project_id: '',
  folder_id: '',
  code: '',
  name: '',
  external_id: '',
  created_on: '',
  modified_on: '',
  pipeline: {},
  widget: {},
  agent_tools: {},
};
